import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { ADDON_KEYS } from "../utils/shopifyCheckout";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

/* Gastos de envío ficticios (modo demo) para Marbella */
export const DELIVERY_FEE = 9;

const sameConfig = (a, b) =>
    a.productId === b.productId &&
    (a.options.roseCount || "") === (b.options.roseCount || "") &&
    (a.options.teddyColor || "") === (b.options.teddyColor || "") &&
    (a.options.shirt || false) === (b.options.shirt || false) &&
    (a.options.shirtColor || "") === (b.options.shirtColor || "") &&
    (a.options.shirtText || "") === (b.options.shirtText || "") &&
    (a.options.message || "") === (b.options.message || "") &&
    (a.options.deliveryDate || "") === (b.options.deliveryDate || "") &&
    (a.options.cardStyle || "") === (b.options.cardStyle || "") &&
    (a.options.packExtra || false) === (b.options.packExtra || false) &&
    (a.options.properties ? JSON.stringify(a.options.properties) : "") ===
        (b.options.properties ? JSON.stringify(b.options.properties) : "");

const load = () => {
    try {
        return JSON.parse(localStorage.getItem("asa-cart") || "[]");
    } catch {
        return [];
    }
};

export function CartProvider({ children }) {
    const [items, setItems] = useState(load);
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        localStorage.setItem("asa-cart", JSON.stringify(items));
    }, [items]);

    const addItem = (item) => {
        setItems((prev) => {
            const existing = prev.find((it) => sameConfig(it, item));
            if (existing) {
                return prev.map((it) =>
                    it.lineId === existing.lineId ? { ...it, qty: it.qty + item.qty } : it
                );
            }
            return [
                ...prev,
                {
                    ...item,
                    lineId: `${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
                },
            ];
        });
    };

    const updateQty = (lineId, delta) =>
        setItems((prev) =>
            prev
                .map((it) =>
                    it.lineId === lineId ? { ...it, qty: Math.max(0, it.qty + delta) } : it
                )
                .filter((it) => it.qty > 0)
        );

    const removeItem = (lineId) =>
        setItems((prev) => prev.filter((it) => it.lineId !== lineId));

    const openCart = () => setIsOpen(true);
    const closeCart = () => setIsOpen(false);

    const subtotal = items.reduce((s, it) => s + it.unitPrice * it.qty, 0);
    const count = items.reduce((s, it) => s + it.qty, 0);
    /* Livraison offerte dès 2 articles (produit + options dédiées), aligné
       sur la réduction automatique Shopify (quantité minimale 2) */
    const addonCount = items.reduce((s, it) => {
        const props = it.options.properties || [];
        let a = props.filter(([k]) => k === "Extra" || ADDON_KEYS.includes(k)).length;
        if (it.options.shirtText) a += 1;
        return s + a * it.qty;
    }, 0);
    const freeDelivery = count + addonCount >= 2;

    const value = useMemo(
        () => ({
            items,
            isOpen,
            addItem,
            updateQty,
            removeItem,
            openCart,
            closeCart,
            subtotal,
            count,
            deliveryFee: freeDelivery ? 0 : DELIVERY_FEE,
            freeDelivery,
        }),
        [items, isOpen]
    );

    return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
}
